module.exports = __webpack_public_path__ + "img/icon-toggle-en.11ccc373.svg";